<div class="cards">
	<div class="cards-wrapper">
		<div *ngIf="selected">
			<div class="credit-card {{ selected.card.brand }}">
				<div class="credit-card-brand">
					<img src="../../../../assets/img/cards/visa.png" class="credit-card-brand-source" alt="Card Brand">
				</div>
				<div class="credit-card-info">
					<div class="credit-card-info-last4">Visa ending in {{ selected.card.last4 }}</div>
					<div class="credit-card-info-expiration">Expiry {{selected.card.exp_month}}/{{selected.card.exp_year}}</div>
				</div>
				<a href="javascript:;" class="add-select-card" (click)="openCardsModal()">Change Payment Method</a>
			</div>
		</div>
	</div>
	<a href="javascript:;" *ngIf="!hideNewCardOption" class="add-select-card mt-10" (click)="useNewCard.emit()">Use a new card</a>
</div>
<app-list-stripe-cards-modal *ngIf="paymentMethods" (selectedCard)="setSelectedCard($event)"
	[currentSubscription]="currentSubscription" [customer]="customer" [user]="user"></app-list-stripe-cards-modal>
